import axios from "./axios";
import language from "./language";

function sanitize_data(data: any) {
    if (data.interest == "") {
        data.interest = [];
    } else if (data.interest != null) {
        if (data.interest == "NaN") {
            data.interest = [];
        } else {
            data.interest = data.interest.split(",");
        }
        //map to integer
        data.interest = data.interest.map((value: string) => {
            return parseInt(value);
        });
    } else {
        data.interest = [];
    }

    if (data.receive_newsletter == 1) {
        data.receive_newsletter = true;
    } else {
        data.receive_newsletter = false;
    }

    if (data.receive_email == 1) {
        data.receive_email = true;
    } else {
        data.receive_email = false;
    }

    if (data.receive_promo == 1) {
        data.receive_promo = true;
    } else {
        data.receive_promo = false;
    }

    if (data.country_region == 0) {
        data.country_region = null;
    }

    return data;


}

async function verify_phone_2(phone_area_code: string, phone: string, question_id: number, answer: string) {
    const { data } = await axios.post("member/step-2", {
        lang: language(),
        phone_area_code,
        phone,
        type: 1,
        question_id,
        answer,
        //  recaptcha_token: await window.grecaptcha.execute('6LdoWDIpAAAAAEaCpBaxQj_fm81y7SjBAZeAd_7f', { action: 'submit' })
    });

    if (data.message == "OK") {
        data.data = sanitize_data(data.data);
    }
    return data;
}

async function verify_email_2(email: string, question_id: number, answer: string, phone_area_code: any) {
    const { data } = await axios.post("member/step-2", {
        lang: language(),
        email,
        type: 2,
        question_id,
        answer,
        phone_area_code,
        //   recaptcha_token: await window.grecaptcha.execute('6LdoWDIpAAAAAEaCpBaxQj_fm81y7SjBAZeAd_7f', { action: 'submit' })
    });

    if (data.message == "OK") {
        data.data = sanitize_data(data.data);
    }
    return data;
}

async function verify_member_no_2(member_no: string, question_id: number, answer: string, phone_area_code: any) {
    const { data } = await axios.post("member/step-2", {
        lang: language(),
        member_no,
        type: 3,
        question_id,
        answer,
        phone_area_code,
        //  recaptcha_token: await window.grecaptcha.execute('6LdoWDIpAAAAAEaCpBaxQj_fm81y7SjBAZeAd_7f', { action: 'submit' })
    });


    if (data.message == "OK") {
        data.data = sanitize_data(data.data);
    }
    return data;

}

export {
    verify_phone_2,
    verify_email_2,
    verify_member_no_2
}


